module.exports = __webpack_public_path__ + "img/ic_facebook.8161869f.svg";